import { render } from "./AposLocalePicker.vue?vue&type=template&id=1ad6ba34&scoped=true"
import script from "./AposLocalePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AposLocalePicker.vue?vue&type=script&setup=true&lang=js"

import "./AposLocalePicker.vue?vue&type=style&index=0&id=1ad6ba34&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad6ba34"],['__file',"ui/ui/apos/components/AposLocalePicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ad6ba34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ad6ba34', __exports__)) {
    api.reload('1ad6ba34', __exports__)
  }
  
  module.hot.accept("./AposLocalePicker.vue?vue&type=template&id=1ad6ba34&scoped=true", () => {
    api.rerender('1ad6ba34', render)
  })

}


export default __exports__